import React, { Component } from "react";
import SharedStateProvider from "./contexts/shared-state/SharedStateProvider";
import Navigator from "./components/general/Navigator";
import { useTranslation } from "react-i18next";


class App extends Component {
  async componentDidMount() {
    //FIXME: should ask for permission, currently it grants it automatically
    // window.addEventListener("beforeunload", (e) => {
    //   e.preventDefault();
    //   // sessionStorage.clear();
    //   e.returnValue = "";
    // });
  }

  render() {
    window.onload = () => {
      document.querySelector("html").dir = sessionStorage.getItem("dir") || "ltr";
    };
    
    return (
      <SharedStateProvider>
        <Navigator />
      </SharedStateProvider>
    );
  }
}
export default App;
